<div class="flex-column-layout cached-files main-text-font">
  <app-portal-header>
  </app-portal-header>
  <div class="flex-row-layout justify-content-end">
    <button type="button" class="base-button refresh-button" (click)="refresh()">Refresh</button>
    <button type="button" class="base-button clearall-button" (click)="deleteAll()">Clear All</button>
  </div>
  <mat-table [dataSource]="dataSource"
             matSort
             matSortActive="Name"
             matSortDirection="asc"
             class="mat-elevation-z0 w-100">
    <ng-container matColumnDef="Name">
      <mat-header-cell *matHeaderCellDef style="background-color: rgba(141,192,219,.25)" mat-sort-header="name">
        <span>Name</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{element.name}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Path">
      <mat-header-cell *matHeaderCellDef>
        <span>Path</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{element.path}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Size">
      <mat-header-cell *matHeaderCellDef>
        <span>Size</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{element.size}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Delete">
      <mat-header-cell *matHeaderCellDef>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <button type="button" class="delete-button" (click)="deleteFile(element)">Delete</button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Filter">
      <mat-header-cell *matHeaderCellDef>
        <input type="text" style="width: 100%;flex-grow: 1" (keyup)="filterTable($event)">
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="void">
      <mat-header-cell *matHeaderCellDef>
      </mat-header-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns; sticky: true"></mat-header-row>
    <mat-header-row *matHeaderRowDef="['Filter','void','void','void']" style="height: 20px"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columns"></mat-row>
  </mat-table>
  <app-footer3></app-footer3>
</div>


